export const DEFAULT_YANDEX_MAP_KEY = "";
export const DEFAULT_YANDEX_MAP_LANG = "ru_RU";
export const DEFAULT_YANDEX_MAP_VERSION = "2.1";
export const DEFAULT_MAP_CENTER = [55.76, 37.64];
export const DEFAULT_MAP_ZOOM = 14;
export const DEFAULT_MIN_ZOOM = 5;
export const DEFAULT_MAX_ZOOM = 18;
export const DEFAULT_MAP_GRID_SIZE = 100;
export const DEFAULT_MIN_SHOPS_SEARCH_STRING_LENGTH = 3;
export const DEFAULT_SEARCH_UPDATE_DEBOUNCE_TIME = 600;
